const iterate=(value,token)=>{
const index=getArrayIndex(value,token);
return[{value:value[index],prop:index,missing:index>=value.length}]
};












export const getArrayIndex=(value,token)=>
token>0||Object.is(token,+0)?token:Math.max(value.length+token,0);

export const INDEX_TOKEN={
name:"index",
valueType:"array",
iterate
};